import { useQuery } from "@tanstack/react-query"
import {
  getListBestRatingTeachers,
  getListTeachersByBadge,
  getListUniqueClassTeachers,
} from "api/teacher.api.ts"
import HeaderBackgroundImage from "assets/hero-image.webp"
import styled from "styled-components"
import { FiltersSection } from "ui/blocks/filtersSection/FiltersSection"
import { MobileFiltersSection } from "ui/blocks/filtersSection/mobileFilterSection"
import { MainLayout } from "ui/layout/MainLayout.jsx"
import { mediaSizes, maxContainerWidth, fullWidthContainerStyles } from "ui/theme"
import { BestInstructors } from "./sections/BestInstructors"
import { Categories } from "./sections/Categories"
import { DownloadSection } from "./sections/DownloadSection"
import { HomeMapSection } from "./sections/HomeMapSection"
import { HowItWorks } from "./sections/HowItWorks"
import { PopularClasses } from "./sections/PopularClasses"
import { Testimonials } from "./sections/Testimonials"

export const HomePage = () => {
  const { data: popularClasses } = useQuery({
    queryKey: ["list-best-rating-teachers"],
    queryFn: () => getListBestRatingTeachers(30),
  })

  const { data: bestInstructors } = useQuery({
    queryKey: ["list-teachers-by-badge"],
    queryFn: () => getListTeachersByBadge({ limit: 30, badge: "top" }),
  })

  const { data: uniqueClasses } = useQuery({
    queryKey: ["list-unique-class-teachers"],
    queryFn: () => getListUniqueClassTeachers(30),
  })

  return (
    <MainLayout primary>
      <HeroSection>
        <HeroContent>
          <HeroTitle>
            Book private lessons with talented musicians near you or online
          </HeroTitle>
          <MobileFiltersSection />
          <FiltersSection />
        </HeroContent>
      </HeroSection>
      <HomeContainer>
        <Categories />
        <PopularClasses popularClasses={popularClasses?.data} />
        <HowItWorks />
        <BestInstructors bestInstructors={bestInstructors?.data} />
        <HomeMapSection />
        {/* <UniqueClasses uniqueClasses={uniqueClasses?.data} /> */}
        <Testimonials />
        <DownloadSection />
      </HomeContainer>
    </MainLayout>
  )
}

const HomeContainer = styled.div`
  
  min-height: var(--page-height);
  margin-inline: auto;

  /* Categories */
  & > :nth-child(1) {

  }

  /* PopularClasses */
  & > :nth-child(2) {

  }

  /* HowItWorks */
  & > :nth-child(3) {
    margin: 72px auto 100px;
    max-width: 1200px;
  }

  /* BestInstructors */
  & > :nth-child(4) {
 
  }

  /* HomeMapSection */
  & > :nth-child(5) {
    ${fullWidthContainerStyles}
    padding-top: 72px;

    @media (max-width: 600px) {
      padding-top: 30px;
    }
  }

  /* Testimonials */
  & > :nth-child(6) {
    ${fullWidthContainerStyles}
    margin-top: 137px;

    @media (max-width: 600px) {
      margin-top: 60px;
    }
  }

  /* DownloadSection */
  & > :nth-child(7) {
    ${fullWidthContainerStyles}
    padding-top: 50px;
    padding-bottom: 70px;

    @media (max-width: 1024px) {
      padding-top: 30px;
      padding-bottom: 50px;
    }
  }

`

const HeroSection = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url("${HeaderBackgroundImage}");
  background-size: cover;
  background-position: 50% 80%;
  background-repeat: no-repeat;
  &::after {
    content: "";
    position: absolute;
    inset: 0;
    background: rgba(20, 20, 20, 0.5);
    z-index: 1;
  }

  @media (width >= ${mediaSizes.md}) {
    min-height: 500px;
    height: calc(100vh - 240px);
    max-height: 630px;
    align-items: flex-end;
  }

`

const HeroContent = styled.div`
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 994px;
  margin: auto;
  padding: 80px 24px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  

  @media (max-width: 768px) {
    padding: 90px 16px 60px;
    gap: 28px;
  }

  @media (max-width: 480px) {
    padding: 75px 16px 48px;
    gap: 24px;
  }
`

const HeroTitle = styled.div`
  font-weight: 500;
  font-size: 30px;
  line-height: 1.2;
  text-align: center;
  color: white;
  max-width: 90%;

  @media (min-width: 640px) {
    font-size: 36px;
  }

  @media (width >= ${mediaSizes.md}) {
    font-size: 39px;
  }
`

